import{fromEvent as o}from"rxjs";export var onWindowResize=o(window,"resize");